module.exports = __webpack_public_path__ + "static/media/valor2.d4b64acd.png";